import { EventCodes } from '../../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.FavouritesService', FavouritesService);
FavouritesService.$inject = [
	'$q',
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.shell.LeftSidebarService',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.shell.AppsService',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.shell.NavigationService',
];

export function FavouritesService(
	$q,
	i18n,
	eventService,
	leftSidebarService,
	personalizationService,
	widgetManager,
	appsService,
	sidePanelService,
	entityService,
	navigationService
) {
	var self = this;
	var initialized = false;
	var favouriteViews = [];
	var favouriteNavigations = [];

	self.init = init;
	self.toggleViewFavourite = toggleViewFavourite;
	self.openFavouriteView = openFavouriteView;
	self.isFavouriteEnabled = isFavouriteEnabled;
	self.toggleNavigationFavourite = toggleNavigationFavourite;
	self.filterNavigations = filterNavigations;

	return self;

	function init() {
		appsService.getCurrentApplication().then(function (app) {
			self.enabled = !app.simpleNavigation && app.showFavourites;

			if (self.enabled && !initialized) {
				initService();
			}
		});
	}

	function initService() {
		initialized = true;

		leftSidebarService.addPanel({
			name: 'favourites',
			icon: 'star',
			title: i18n.get('solutionBuilderAgent.components.mx-favourites-items-panel.favouritesViews'),
			order: 30,
			disable: true,
			content: '<mx-favourites-items-panel></mx-favourites-items-panel>',
		});

		Object.defineProperty(self, 'favouriteViews', {
			get: function () {
				return favouriteViews;
			},
		});

		Object.defineProperty(self, 'favouriteNavigations', {
			get: function () {
				return favouriteNavigations;
			},
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ObjectDataDeleted, function (e, data) {
			if (data && Array.isArray(data.affectedObjectIds)) {
				data.affectedObjectIds.forEach(function (objectId) {
					var object = { Id: objectId };

					if (objectIsFavourite(object)) {
						removeViewFromFavourites(object);
					}
				});
			}
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ObjectDisplayNameChanged, function (e, params) {
			var needSave = false;
			favouriteViews.forEach(function (view) {
				if (view.id === params.objectId && view.type === params.entityType) {
					view.displayName = params.displayName;
					needSave = true;
				}
			});
			if (needSave) {
				saveFavouriteViews();
			}
		});

		eventService.subscribeGlobal(mx.SolutionBuilderAgent.Events.ViewDataLoaded, function (e, view) {
			if (view) {
				view.favourite = objectIsFavourite(sidePanelService.getObjectDetailsFromView(view));
			}
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.ObjectRemovedByWizard, function (e, object) {
			if (objectIsFavourite(object)) {
				removeViewFromFavourites(object);
			}
		});

		eventService.subscribeGlobal(mx.shell.EventCodes.NavigationReload, function () {
			initNavigationItems();
		});

		initFavouriteViews();
		initNavigationItems();
	}

	async function initFavouriteViews() {
		const favouritesObjectDetails = await personalizationService.getFavouriteViews();
		const views = await Promise.all(favouritesObjectDetails.map((objectDetails) => widgetManager.getPreviewView(objectDetails)));
		favouriteViews.length = 0;
		views.filter((view) => view && typeof view === 'object').forEach((view) => favouriteViews.push(view));
		checkFavouritesPanelStatus();
	}

	function toggleViewFavourite(view) {
		var favouriteObject = sidePanelService.getObjectDetailsFromView(view);

		if (objectIsFavourite(favouriteObject)) {
			removeViewFromFavourites(favouriteObject);
			view.favourite = false;
		} else {
			addViewToFavourites(favouriteObject);
			view.favourite = true;
		}
	}

	async function addViewToFavourites(objectDetails) {
		const view = await widgetManager.getPreviewView(objectDetails);

		if (view) {
			eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
				eventName: 'Item added to Favorites',
				view,
			});
			favouriteViews.push(view);
			checkFavouritesPanelStatus();
			saveFavouriteViews();
		}
		return favouriteViews;
	}

	function removeViewFromFavourites(objectDetails) {
		favouriteViews.some(function (fView, index) {
			if (fView.id === objectDetails.Id && (!objectDetails.EntityType || fView.type === objectDetails.EntityType)) {
				const [removedView] = favouriteViews.splice(index, 1);
				eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
					eventName: 'Item removed from Favorites',
					view: removedView,
				});
				return true;
			}
		});
		checkFavouritesPanelStatus();
		saveFavouriteViews();
		return $q.when(favouriteViews);
	}

	function saveFavouriteViews() {
		personalizationService.saveFavouriteViews(favouriteViews.map(sidePanelService.getObjectDetailsFromView));
	}

	function objectIsFavourite(objectDetails) {
		return favouriteViews.some(function (fView) {
			return objectDetails.Id === fView.id && (!objectDetails.EntityType || objectDetails.EntityType === fView.type);
		});
	}

	function initNavigationItems() {
		personalizationService.getFavouriteNavigations().then(function (favouriteNavigationIds) {
			navigationService.get().then(function (navItems) {
				favouriteNavigations = [];
				navItems.forEach(function (item) {
					initItem(item, favouriteNavigationIds);
				});

				if (favouriteNavigationIds.length) {
					favouriteNavigationIds.forEach(function (itemId) {
						navigationService.getNavigationItem(itemId).then(function (item) {
							initItem(item, favouriteNavigationIds);
						});
					});
				}
				checkFavouritesPanelStatus(favouriteNavigationIds);
			});
		});
	}

	function initItem(item, favouriteNavigationIds) {
		var idx = favouriteNavigationIds.indexOf(item.id);
		if (idx >= 0) {
			item.favourite = true;
			favouriteNavigations.push(item);
			favouriteNavigationIds.splice(idx, 1);
		}
		if (item.children.length) {
			item.children.forEach(function (chItem) {
				initItem(chItem, favouriteNavigationIds);
			});
		} else {
			setNavigationShowInFavourite(item);
		}
	}

	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.FavouritesService#filterNavigations
	 *
	 * @description
	 * applies value of filter in Favourites Items panel to current favourites Navigation Items set
	 *
	 * @param {string} filterText - value of search box in Favourites Items panel
	 *
	 * @returns {array} an array of Navigation Items which contains filterText in title.
	 */
	function filterNavigations(filterText) {
		if (!filterText) {
			initNavigationItems();
			return;
		}
		filterText = filterText.toLowerCase();

		favouriteNavigations.forEach(function (item) {
			item.showInFavorite = item.title.toLowerCase().indexOf(filterText) >= 0;
		});
	}

	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.FavouritesService#toggleNavigationFavourite
	 *
	 * @description
	 * toggles state of showing in favourite panel for Navigation Item
	 *
	 * @param {MxNavigationItem} favouriteItem - a Navigation Item for toggling state of showing
	 */
	function toggleNavigationFavourite(favouriteItem) {
		if (favouriteItem.favourite) {
			var index = favouriteNavigations.indexOf(favouriteItem);
			if (index >= 0) {
				favouriteNavigations.splice(index, 1);
				favouriteItem.favourite = false;
				setNavigationShowInFavourite(favouriteItem);

				eventService.dispatchEvent(EventCodes.TrackTelemetry, {
					eventName: 'Navigation item removed from Favorites',
					sender: favouriteItem.id,
					senderTitle: favouriteItem.technicalName,
				});
			}
		} else {
			favouriteNavigations.push(favouriteItem);
			favouriteItem.favourite = true;
			setNavigationShowInFavourite(favouriteItem);

			eventService.dispatchEvent(EventCodes.TrackTelemetry, {
				eventName: 'Navigation item added to Favorites',
				sender: favouriteItem.id,
				senderTitle: favouriteItem.technicalName,
			});
		}
		saveFavouriteNavigations();
		checkFavouritesPanelStatus();
	}

	function setNavigationShowInFavourite(item) {
		item.showInFavorite = item.favourite;
		if (item.children.length) {
			item.children.some(function (subItem) {
				if (subItem.showInFavorite) {
					item.showInFavorite = true;
				}
			});
		}
		if (item.parent) {
			setNavigationShowInFavourite(item.parent);
		}
	}

	function saveFavouriteNavigations() {
		personalizationService.saveFavouriteNavigations(
			favouriteNavigations.map(function (item) {
				return item.id;
			})
		);
	}

	function checkFavouritesPanelStatus() {
		if (favouriteViews.length || favouriteNavigations.length) {
			leftSidebarService.enablePanel('favourites');
		} else {
			leftSidebarService.disablePanel('favourites');
		}
	}

	function openFavouriteView(view) {
		eventService.dispatchEvent(EventCodes.TrackViewTelemetry, {
			eventName: 'Favorites item opened',
			view,
		});

		var objDetails = sidePanelService.getObjectDetailsFromView(view);
		var typeName = (objDetails.EntityType || '').toLowerCase();

		if (typeName === 'spsactivitytypeticket' || typeName === 'spsactivitytypeincident' || typeName === 'spsactivitytypeservicerequest') {
			entityService.getObjectTypeName(objDetails.Id).then(function (typeName) {
				if (typeName) {
					objDetails.EntityType = typeName;
				}
				internalOpenFavouriteView(view, objDetails);
			});
		} else {
			internalOpenFavouriteView(view, objDetails);
		}
	}

	function internalOpenFavouriteView(view, objDetails) {
		widgetManager.getPreviewView(objDetails).then(function (newView) {
			/* check if type of the object hasn't been changed. Ex.: ticket onto incident. If type was changed -> set new view */
			if (!newView || view.type === newView.type) {
				sidePanelService.addView(view).catch(mx.logCatch);
			} else {
				var favIndex = favouriteViews.indexOf(view);
				if (favIndex >= 0 && newView) {
					favouriteViews.splice(favIndex, 1, newView);
				}
				if (newView) {
					sidePanelService.addView(newView).catch(mx.logCatch);
				}
			}

			sidePanelService.handleItemSelectionOnMobile();
		});
	}

	function isFavouriteEnabled(view, navigationItem) {
		return (
			self.enabled &&
			(navigationItem ||
				(view &&
					sidePanelService.getObjectDetailsFromView(view).Id &&
					(view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview || view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit)))
		);
	}
}
